import { render } from "./MessageCartForm.vue?vue&type=template&id=2a7ff286&scoped=true"
import script from "./MessageCartForm.vue?vue&type=script&lang=js"
export * from "./MessageCartForm.vue?vue&type=script&lang=js"

import "./MessageCartForm.vue?vue&type=style&index=0&id=2a7ff286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7ff286"]])

export default __exports__